import { newColors } from "constants/newColors";
import styled from "styled-components";

import { Megaphone } from "@styled-icons/bootstrap/Megaphone";

export const StyledAnnounceArea = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  padding: 10px;
  box-sizing: border-box;
  border-radius: 10px;
  background: ${newColors.announceBackground};

  @media print {
    break-inside: avoid;
  }
`;

export const StyledTitleArea = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

export const StyledContentArea = styled.div`
  height: fit-content;
`;

export const StyledMegaphone = styled(Megaphone)`
  position: relative;
  bottom: 1px;

  width: 14px;
  height: 14px;
  color: ${newColors.text};
`;
